import React, { useRef } from "react";
import { Box } from "@mui/material";
import "./style";
import Grid from "@mui/material/Grid2";
import {
  StyleBoxMain,
  StyledBoxWidth,
  StyledGrid,
  StyledGridContainer,
} from "./style";
import Logo from "../../../assets/images/nativeLogo.png";
import AuthImage from "../../../components/common/auth/AuthImage";
import SignUpForm from "../../../components/auth/sign-up/SignUpForm";
import { useDispatch, useSelector } from "react-redux";
import { REGISTER } from "../../../actions/AuthActions";

const SignUp = () => {
  const dispatch = useDispatch();
  const submitLock = useRef(false);
  const isSubmitting = useSelector((state) => state?.auth?.isLoading);

  const handleRegister = (payload) => {
    if (submitLock.current || isSubmitting) return;
    submitLock.current = true;

    dispatch({
      type: REGISTER,
      payload: {
        ...payload,
        onError: () => {
          submitLock.current = false;
        },
      },
    });
  };

  return (
    <>
      <StyleBoxMain>
        <StyledBoxWidth>
          <StyledGridContainer container>
            <Grid size={{ md: 7, xs: 0 }}>
              <AuthImage />
            </Grid>

            <StyledGrid size={{ md: 5, xs: 12 }}>
              <Box>
                <img loading="lazy" src={Logo} alt="Login Visual" />
              </Box>
              <SignUpForm onSubmit={handleRegister} isSubmitting={isSubmitting} />
            </StyledGrid>
          </StyledGridContainer>
        </StyledBoxWidth>
      </StyleBoxMain>
    </>
  );
};

export default SignUp;
